module.exports = __webpack_public_path__ + "img/coin.7b5b22ad.svg";